import React, { useEffect, useState } from "react";
import { Button, CardBody, Col, FormGroup, Label, Row } from "reactstrap";
import { Controller } from "react-hook-form";
import Typeahead from "../../../CommonElements/TypeAhead/index";
import { DefaultCurrency, DefaultLang, Submit } from "../../../Constant";
import HandleApiError from "../../Common/ErrorImport/ErrorImport";
import { getClientUrlDataToken } from "../../../Utils/restUtils";
import { getCurrency } from "../../../CommonUrl";
import { useSelector } from "react-redux";

const languageOptions = [{ value: "english", label: "ENGLISH (GB)" }];


const DefaultForm = ({ register, control }) => {

    const [currencyOptions, setCurrencyOptions] = useState([]);
    const authState = useSelector((state) => state.auth);

    const currencyApi = async () => {
        const data = await getClientUrlDataToken(authState.apiUrl, getCurrency);
        if (data.status === true) {
            const transformedData = data.data.map((item) => ({
                label: item.name,
                value: item.code
            }));
            setCurrencyOptions(transformedData);
        } else {
            HandleApiError(response.status)
        }
    };

    useEffect(() => {
        currencyApi();
    }, [])
    

  return (
    <CardBody>
    <Row className="g-3">
        <Col md="6">
            <FormGroup className="mb-3">
                <Label htmlFor="language">{DefaultLang}</Label>
                <Controller
                    name="language"
                    control={control}
                    defaultValue={languageOptions[0]}
                    render={({ field }) => (
                        <Typeahead
                            id="language"
                            options={languageOptions}
                            onChange={(value) => {
                                field.onChange(value);
                            }}
                            value={field.value}
                        />
                    )}
                />
            </FormGroup>
        </Col>
        <Col md="6">
            <Label htmlFor="currency">{DefaultCurrency}</Label>
            <Controller
                name="currency"
                control={control}
                defaultValue={currencyOptions[0]}
                render={({ field }) => (
                    <Typeahead
                        options={currencyOptions}
                        onChange={(value) => {
                            field.onChange(value);
                        }}  
                        value={field.value}
                    />
                )}
            />
        </Col>
    </Row>
    <div className="pt-3 text-end">
        <span className="ps-2 spinner-enable">
            <Button className="btn" type="submit">{Submit}</Button>
        </span>
    </div>
</CardBody>
)
}

export default DefaultForm